import {UI} from "stem-core/src/ui/UI.js";
import {ConfirmationModal} from "../../../../blinkpay/ui/ConfirmationModal.jsx";
import {LoadingSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {CardItems} from "../../ui/CardItems.jsx"
import {Money} from "../../../../stem-core/src/localization/Money.js";
import {FormatPaymentMethodDescription} from "../../../../blinkpay/common/PaymentMethodDescription.jsx";


export class RevertTopUpModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: "Revert charge",
            confirmLabel: "Revert",
            confirmAction: () => this.revertTopUp(),
        }
    }

    async revertTopUp() {
        const {charge} = this.options;

        await this.makeRequest("/admin/top_up_payments/revert_charge",{chargeId: charge.id});
    }

    render() {
        const {user, charge} = this.options;
        const paymentMethod = charge.getPaymentMethod();

        return [
            <CardItems items={[
                ["Email", user.email],
                ["Payment method", FormatPaymentMethodDescription(paymentMethod)],
                ["Top up amount", Money.format(charge)],
                ["Top up date", charge.createdAt]
            ]}
            />,
            this.waitingForResponse && <LoadingSpinner/>,
        ];
    }
}
